/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-02 17:05:12
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-06 18:54:21
 */
const consultation = [
    // 问诊列表
    {
        path: '/consultation/list',
        name: 'consultationList',
        component: () => import('../views/consultation/list.vue'),
    },
    // 老版本迁移--问诊列表
    {
        path: '/chatlist/1',
        name: 'chatlist',
        component: () => import('../views/consultation/list.vue'),
    },
]
export default consultation



// WEBPACK FOOTER //
// ./src/router/consultation.js